import { render, staticRenderFns } from "./SexyGaming.vue?vue&type=template&id=14c781d2&scoped=true"
import script from "./SexyGaming.vue?vue&type=script&lang=js"
export * from "./SexyGaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c781d2",
  null
  
)

export default component.exports